import React from 'react'
import { NewsLetterDiv} from './style'
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';

function NewsLetter() {
    return (
        <NewsLetterDiv>
            <div className="inner-container">
                <div className=" pt-5 news">
                    <h3>Subscribe to our <span>Newsletter</span></h3>
                    <p>Subscribe to our newsletter to get update about us</p>
                    <form >
                        <div className="input-group">
                            <input type="text" class="form-control" placeholder="Subscribe" />
                            <div className="input-group-btn">
                            <button className="btn btn-default bt1" type="submit">
                                Subscribe 
                                <IoMdCheckmarkCircleOutline />
                            </button>
                            <button className="btn btn-default bt2" type="submit">
                                <IoMdCheckmarkCircleOutline />
                            </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </NewsLetterDiv>
    )
}

export default NewsLetter
